<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.mpsId"
                selectType="select"
                requestApi="/scp/scpSopMpsSupplierAssignRatio/mpsDataBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.productBroadCategory"
                selectType="select"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="内外部">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.scpSupplierCategory"
                selectType="select"
                :selectData="listSideOpinions"
                :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <!-- <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.listSupplier"
                selectType="selectMultiple"
                requestApi="/scp/scpMpsPlans/listMpsSupplierName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              /> -->
              <global-select
                :value.sync="queryParams.supplierAbbreviation"
                selectType="selectSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <!-- 物料编码 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemId"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMpsPlans/listItemCodeCp"
                :assembleLabel="true"
                :selectItem="{ value: 'realValue', label: 'selectedValue', thirdLabel: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button :loading="isRefreshing" @click="handleRefresh" type="primary">刷新</a-button>
      <a-button @click="handleExport" type="primary">导出</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :selectedRows.sync="selectedRows"
            :multi-select="true"
            :tableProps="tableProps"
            rowKey="mpsId"
            :scroll="{ fixScreen: true, x: 1300 }"
            @selectedRowChange="selectedRowChange"
          >
            <template slot="fixedEllipsis" slot-scope="{ text, column }">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ text }}</span>
                </template>
                <span :style="{ width: `${column.width - 32}px` }" class="ellipsis">{{ text }}</span>
              </a-tooltip>
            </template>
            <template slot="columnData" slot-scope="{ record, column }">
              <span>{{ record[column.dataIndex]?(record[column.dataIndex]+'%'):'' }}</span>
            </template>
            <!-- 操作 -->
            <span slot="operation" slot-scope="{ record }">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDel(record)">删除</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleSend(record)" >发布</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
          </ls-api-table>
        </a-spin>
      </div>
    </template>

  </ls-table-layout>
</template>
<script>
import {
  apiScpSopFcInitialDeliveryRatio,
  apiDelScpSopFcInitialDeliveryRatio
} from '@/api/scp/shipmentForecast/shipmentForecastSetting'
import { generateLsTableResData } from '@/utils/util.js'
import { apiScpSopMpsSupplierAssignRatioList, apiScpSopMpsSupplierAssignRatio } from '@/api/mps/basic-data/material-allocation-ratio.js'

export default {
  // eslint-disable-next-line
  name: 'Material-allocation-ratio',
  components: {

  },
  props: {
    id: {
      type: String,
      default: '1' // 设置默认值为'Hello from child'
    }
  },
  data () {
    return {
      isRefreshing: false,
      listSideOpinions: [],
      productBroadCategoryOpinions: [],
      isLoading: false,
      url: '/scp/scpSopFcInitialDeliveryRatio/import',
      isEdit: false,
      tableList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpSopMpsSupplierAssignRatioList, true),
        pageCurrent: true
      },
      columns: [],
      columnsServe: [],
      // 表格字段
      columnsNative: [
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategoryDesc',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'fixedEllipsis' },
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'fixedEllipsis' },
          align: 'center',
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixedEllipsis' },
          align: 'center',
          fixed: 'left'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          width: 220,
          ellipsis: true,
          scopedSlots: { customRender: 'fixedEllipsis' },
          align: 'left',
          fixed: 'left'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierAbbreviation',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '内外部',
          dataIndex: 'scpSupplierCategoryDesc',
          width: 100,
          ellipsis: true,
          align: 'center'
        }
      ],
      queryParams: {
        mpsId: undefined,
        productBroadCategory: undefined,
        supplierAbbreviation: undefined,
        scpSupplierCategory: undefined,
        itemId: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  methods: {
    handleRefresh () {
      if (!this.queryParams.mpsId) {
        this.$message.error('请输入版本')
        return
      }
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要刷新该项的数据项吗?`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.isRefreshing = true
          apiScpSopMpsSupplierAssignRatio({ version: self.versionDescription }).then((response) => {
            self.isRefreshing = false
            if (response.code === 200) {
              self.$message.success('刷新成功')
            } else {
              self.$message.error(response.msg)
            }
          }).catch((e) => { self.isRefreshing = false })
        }
      })
    },
    handleVersionChange (val, selectList) {
      if (val) {
        const filteredItem = selectList.filter((item) => item.realValue === val)
        this.versionDescription = filteredItem[0].label
      }
    },
        /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        mpsId: undefined,
        productBroadCategory: undefined,
        supplierAbbreviation: undefined,
        scpSupplierCategory: undefined,
        itemId: undefined
      }
     // this.onSearch()
    },
        /** 导出按钮操作 */
   handleExport () {
      this.download('scp/scpSopMpsSupplierAssignRatio/export', {
        ...this.queryParams
      }, `供应商分配比例列表_${new Date().getTime()}.xlsx`)
    },
   // 新增/修改框事件
     handleOk () {
        // this.onSearch()
      },
    handleDelete (tableList, record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          const ids = []
          self.columnsServe.forEach((column) => {
            console.log(column.indexKey)
            const id = record[column.indexKey].id
            ids.push(id)
          })
          apiDelScpSopFcInitialDeliveryRatio(ids).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
      const recordCopy = JSON.parse(JSON.stringify(record))
      apiScpSopFcInitialDeliveryRatio(recordCopy).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    getLookupList (type, arr) {
        const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
        }
        this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
        if (type === 'MDM_ORG_SUPPLIER_CLASS') {
            const filteredArray = response.rows.filter(function (obj) {
                return obj.attribute2 === "Y";
                });
                this[arr] = filteredArray
        }
        })
    },
    getTableInfo (id) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      apiScpSopMpsSupplierAssignRatioList(id).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          // this.tableList.forEach((obj, index) => {
          //   obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          // })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              children: title.children.map((childrenTitle) => {
                return {
                          title: childrenTitle.indexName,
                          dataIndex: childrenTitle.indexKey,
                          scopedSlots: { customRender: 'columnData' },
                          width: 120,
                          myTitle: childrenTitle.indexName,
                          align: 'center'
                        }
              })
            }
          })
          const dynamicColumn = this.setNewColumn('scpSupplierCategoryDesc', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch () {
      if (!this.queryParams.mpsId) {
        this.$message.error('请输入版本')
        return
      }
      this.isEdit = false
       this.$refs.dataTable.searchParams = this.queryParams;
      // this.$refs.dataTable.getData();
      this.$refs.dataTable.myPagination.current = 1
      this.getTableInfo({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
    },
    /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    },
    // 编辑
    handleEdit (record, index) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    }
  },
  created () {
    // this.getTableInfo()
    this.queryParams.mpsId = this.$route.query.id
      this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
       this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
  },
  mounted () {
    this.columns = this.columnsNative
    if (this.queryParams.mpsId) {
       this.onSearch()
    }
  }
}
</script>

<style scoped lang="less">
.ellipsis{
  display:block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.content {
  display: flex;
  flex-direction: column;
}
.action-btn {
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 8px 8px 54px;
}
.table {
  flex: 1;
}
</style>
